import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file.svg'


const _withScopeId = n => (_pushScopeId("data-v-4323aff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-files-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "d-files-header__title" }, "My Files", -1))
const _hoisted_3 = { class: "d-layout-switcher" }
const _hoisted_4 = { class: "file-wrapper" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "file" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "casedrive file"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "checker unchecked"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "file-name" }
const _hoisted_16 = {
  class: "file-box spacer",
  ref: "spacer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!
  const _component_app_no_message = _resolveComponent("app-no-message")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", !_ctx.driveStore.isGridFolderView ? 'active icon-list-view-2-active' : 'icon-list-view-2']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.driveStore.isGridFolderView = false))
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.isGridFolderView ? 'active icon-tiles-2-active' : 'icon-tiles-2']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.isGridFolderView = true))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["scroll", {selector: _ctx.selector, 'scroll--hide-footer': _ctx.hideFooter}]),
      onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      ref: "scroller"
    }, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.dataLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.files, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                key: file.id,
                style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
                onClick: ($event: any) => (_ctx.selectFile(file)),
                class: "file-box"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  (_ctx.selector)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (file.selected)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11))
                      ], 64))
                    : (!_ctx.isNetwork)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.deleteFile(file.id)),
                          class: "closer"
                        }, _hoisted_14, 8, _hoisted_12))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(file.name), 1)
              ], 12, _hoisted_5))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.isPageLoading || _ctx.dataLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(15, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "file-box"
              }, [
                _createVNode(_component_app_skeleton_media)
              ])
            }), 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, null, 512)
      ]),
      _withDirectives(_createVNode(_component_app_no_message, {
        icon: _ctx.noPhotosMessage.icon
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.noPhotosMessage.text), 1)
        ]),
        _: 1
      }, 8, ["icon"]), [
        [_vShow, _ctx.noPhotosMessage]
      ])
    ], 34)
  ]))
}